import { CALL_API } from '@aftonbladet/redux-api-middleware';

import { COUPON_CODES_REQUEST, COUPON_CODES_SUCCESS, COUPON_CODES_FAILURE } from './types';

/* eslint-disable import/prefer-default-export */
export const fetchCouponCodesAction = ({ endpoint, force = false }) => ({
    [CALL_API]: {
        endpoint,
        method: 'GET',
        types: [
            COUPON_CODES_REQUEST,
            {
                type: COUPON_CODES_SUCCESS,
                payload: (action, state, res) => res.json(),
            },
            COUPON_CODES_FAILURE,
        ],
        bailout: (state) => !force && !!state.couponCodes.items.length,
    },
});
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/coupon-codes.js
 **/